"use client"

import { useRef } from "react"
import { FiUpload } from "react-icons/fi"

const PDFUploader = ({ onFileUpload }) => {
  const fileInputRef = useRef(null)

  const handleClick = () => {
    fileInputRef.current.click()
  }

  const handleFileChange = (e) => {
    const files = e.target.files
    if (files.length > 0) {
      onFileUpload(files)
      // Reset the input value so the same file can be uploaded again if needed
      e.target.value = null
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const files = e.dataTransfer.files
    if (files.length > 0) {
      const pdfFiles = Array.from(files).filter((file) => file.type === "application/pdf")

      if (pdfFiles.length > 0) {
        onFileUpload(pdfFiles)
      }
    }
  }

  return (
    <div
      className="border-2 border-dashed border-gray-300 rounded-lg p-8 mb-6 text-center cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={handleClick}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        multiple
        accept="application/pdf"
        className="hidden"
      />
      <FiUpload className="mx-auto h-12 w-12 text-gray-400" />
      <p className="mt-2 text-sm text-gray-600">Drag and drop PDF files here, or click to select files</p>
      <p className="mt-1 text-xs text-gray-500">Only PDF files are accepted</p>
    </div>
  )
}

export default PDFUploader
